module.exports = __webpack_public_path__ + "static/inkbox-logo-44b2e493bfc2722857ad2a378b5080a3.png";